/**
 * Session Expired Screen
 * Shown when user's session expires
 * Uses React Router navigate instead of window.location hard reload
 */

import { useNavigate } from 'react-router-dom';

export function SessionExpiredScreen() {
  const navigate = useNavigate();

  const handleSignIn = () => {
    // Redirect to landing page instead of auth page
    navigate('/', { replace: true });
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="space-y-4">
          <div className="mx-auto w-16 h-16 bg-orange-100 dark:bg-orange-900/20 rounded-full flex items-center justify-center">
            <svg
              className="w-8 h-8 text-orange-600 dark:text-orange-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div className="space-y-2">
            <h1 className="text-3xl font-bold">Session Expired</h1>
            <p className="text-muted-foreground">
              Your session has expired. Please return to the home page and sign in again.
            </p>
          </div>
        </div>
        <button
          onClick={handleSignIn}
          className="w-full bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 rounded-md font-medium transition-colors"
        >
          Return to Home
        </button>
      </div>
    </div>
  );
}
